export const GET_RECIPIENT_TYPES_INIT = "RECIPIENT_TYPES:GET_INIT";
export const GET_RECIPIENT_TYPES_SUCCESS = "RECIPIENT_TYPES:GET_SUCCESS";
export const GET_RECIPIENT_TYPES_FAILURE = "RECIPIENT_TYPES:GET_FAIL";
